import { z } from 'zod'

export const FormCreatePriceListProductSchema = z.object({
  produto: z.string().min(1, 'Produto obrigatório'),
  categoria: z.string().min(1, 'Categoria obrigatória'),
  valor: z.string().min(1, 'Valor obrigatório'),
  imagem: z.string().optional(),
})

export type FormCreatePriceListProduct = z.infer<
  typeof FormCreatePriceListProductSchema
>
